import { FC } from "react";
import {
  Stack,
  SxProps,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material"; // Import the Typography component from the appropriate package
import { useQueryPersonInfomation } from "hooks/useQueryPersonInfomation";

type Props = {
  sx?: SxProps<Theme>;
};

export const HeaderPersonInfo: FC<Props> = ({ sx }) => {
  const { isLoading, isError, data } = useQueryPersonInfomation();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md"),
  );

  if (isLoading) return null;
  if (isError) return null;
  if (!data) return null;

  return (
    <Typography sx={sx} color="inherit" component="div">
      <Stack direction="row" spacing={1} useFlexGap>
        <Typography
          color="inherit"
          sx={{
            fontSize: {
              xs: "0.85rem", // スマホサイズで小さく
              md: "inherit", // デスクトップでは通常サイズ
            },
          }}
        >
          {isMobile ? data.item.person_cd : `ID：${data.item.person_cd}`}
        </Typography>
        <Typography
          color="inherit"
          sx={{
            fontSize: {
              xs: "0.85rem", // スマホサイズで小さく
              md: "inherit", // デスクトップでは通常サイズ
            },
          }}
        >
          {isMobile ? data.item.person_name : `氏名：${data.item.person_name}`}
        </Typography>
        <Typography
          color="inherit"
          sx={{
            fontSize: {
              xs: "0.85rem", // スマホサイズで小さく
              md: "inherit", // デスクトップでは通常サイズ
            },
          }}
        >
          {isMobile
            ? data.item.birthday_date
            : `生年月日：${data.item.birthday_date}`}
        </Typography>
      </Stack>
    </Typography>
  );
};
